<app-gene-results *ngIf="results" [mode]="'results'" [results]="results"></app-gene-results>
